export class PartsWantedStatuses {
    public static Open : number    = 1;
    public static Closed : number  = 2;
    public static Expired : number = 3;
}